export function getEmptyFormListObj(formList, ignoreCb, replaceMap = {
    address: {
        streetAddress: '',
        zipCode: '',
        city: '',
        state: ''
    }
}) {
    const obj = {};
    for (let i = 0, len = formList.length; i < len; i++) {
        const name = formList[i].name;
        if (ignoreCb && ignoreCb(formList[i])) {
            continue;
        }
        obj[name] = '';
        if (replaceMap[name]) {
            Object.assign(obj, { ...replaceMap[name] });
        }
    }
    return obj;
}
